// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__if1dc","colBig":"styles_colBig__G9l83","colSmall":"styles_colSmall__24gdE"};